import { render, staticRenderFns } from "./OrganicGrowth.vue?vue&type=template&id=5d248211&"
import script from "./OrganicGrowth.vue?vue&type=script&lang=js&"
export * from "./OrganicGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports